import { editDictionaryTranslation } from './editDictionaryTranslation'
import { deleteDictionaryTranslation } from './deleteDictionaryTranslation'
import { getPaginatedList } from './getPaginatedList'
import { getDictionaryTranslationOptions } from './getDictionaryTranslationOptions'
import { getDictionaryCarlots } from './getDictionaryCarlots'
import { getKeywords } from './getKeywords'

export const Dictionary = {
  getPaginatedList,
  editDictionaryTranslation,
  deleteDictionaryTranslation,
  getDictionaryTranslationOptions,
  getDictionaryCarlots,
  getKeywords,
}
